/**
 * Converts a date string to a short date format.
 * @param {string} d - The date string to be converted.
 * @returns {string} The short date format string.
 */
export default (d) => new Date(d).toISOString().split('T')[0];
